import { BoundedContent, Column, GridContainer, H3, Row, SWAN_STYLE_KEY_MAP } from '@vp/swan'
import { useLogger, useSwanStyleKeys } from '@vp/ubik-context'
import { FaqSection } from './FaqSection'
import SpecialOffersDetail from './SpecialOffersDetail'
import { ContentfulContextProvider, DebugSection, ContentfulLink } from '@vp/mcs-react-tools'
import locales from '../../../localizations/locales'
import { FragmentLogger } from '@vp/ubik-logging'

interface FaqItem {
  answer: string
  contentful_id: string
  question: string
}

interface ContentfulMetadata {
  spaceId: string
  contentful_id: string
  contentfulName: string
  environment?: string
}

export interface FragmentProps {
  faqLabel: string
  faqList: FaqItem[]
  contentLabel: string
  locale: string
  content: string
  contentfulMetadata: ContentfulMetadata
  debugData: Record<string, unknown>
}

export const DealsFaq = ({ faqLabel, faqList, contentLabel, locale, content, contentfulMetadata, debugData }: FragmentProps) => {
  useSwanStyleKeys([SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.grid, SWAN_STYLE_KEY_MAP.accordion])

  const logger = useLogger() as FragmentLogger

  logger.setContext({
    locale,
    entry: contentfulMetadata?.contentful_id,
    name: 'fragment-deals-seo-fragment',
    'vista.team_tag': 'VPD-0001',
  })

  const offerDetailsSectionId = locales[locale]['offerDetailsSection']
  const faqSectionId = locales[locale]['faqSectionId']

  const search = typeof globalThis !== 'undefined' && 'window' in globalThis ? window.location.search : ''

  return (
    <ContentfulContextProvider space={contentfulMetadata?.spaceId || ''}>
      <DebugSection contentfulMetadata={contentfulMetadata} availability={debugData} search={search} />
      <ContentfulLink id={contentfulMetadata?.contentful_id} />
      <BoundedContent paddingX={0}>
        <GridContainer>
          <Row id={faqSectionId} marginTop={{ xs: 7, md: 0 }} marginBottom={{ xs: 7, md: 9 }} backgroundColor="warm-white">
            <FaqSection label={faqLabel} list={faqList} />
          </Row>
          {contentLabel && (
            <Row>
              <Column span={8} push={2} paddingX={{ xs: 5 }}>
                <H3 textAlign="left" marginBottom={0} fontSize="large" fontWeight="bold" data-elementname="Offer Details Section" id={offerDetailsSectionId}>
                  {contentLabel}
                </H3>
                <SpecialOffersDetail content={content} />
              </Column>
            </Row>
          )}
        </GridContainer>
      </BoundedContent>
    </ContentfulContextProvider>
  )
}
